import React, {useEffect, useRef, forwardRef} from "react";

export const SelectRowCheckBox = forwardRef(
  ({ indeterminate, onChange, setEdit, editSingleRow=false, row, isEdit, checked, ...rest }, ref) => {
    const defaultRef = useRef()
    const resolvedRef = ref || defaultRef

    useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate])

    const onRowChange = e => {
      onChange(e);
      if (setEdit) {
        if (row === "all") {
          return;
        }
        if (editSingleRow) {
          setEdit({[row.index]: row.index in isEdit && isEdit[row.index]? !isEdit[row.index]:true});
        } else {
          setEdit({[row.index]: !checked});
        }
      }
    };

    return (
      <>
        <input type="checkbox" ref={resolvedRef} onChange={onRowChange} checked={editSingleRow?row.index in isEdit && isEdit[row.index]: checked} {...rest}/>
      </>
    )
  }
);
